module.exports = __webpack_public_path__ + "img/drop-down-black.12d0a4e0.svg";